import axios from 'axios'
import { isDmsRequestContextChanged } from '@/modules/file/_helpers/dms-request-context-error'

interface PreviewDocument {
  data?: unknown,
  minioId?: string,
  url?: string,
}

interface LoadDocumentPreviewDataOptions {
  createObjectUrl?: (data: Blob) => string,
  document: PreviewDocument,
  dmsFileUrl?: string,
  fetchDocument?: (url: string, options: object) => Promise<{ data: unknown }>,
  httpHeaders: object,
  isPdf: boolean,
  streamDmsFile: (minioId: string) => Promise<unknown>,
}

export const loadDocumentPreviewData = async({
  createObjectUrl = URL.createObjectURL,
  document,
  dmsFileUrl,
  fetchDocument = axios.get,
  httpHeaders,
  isPdf,
  streamDmsFile,
}: LoadDocumentPreviewDataOptions): Promise<unknown> => {
  if (document.minioId && dmsFileUrl) {
    try {
      return await streamDmsFile(document.minioId)
    } catch (error) {
      if (isDmsRequestContextChanged(error)) throw error
      if (!document.url) throw error
    }
  }

  if (document.url) {
    const responseType = isPdf ? 'blob' : 'text'
    const { data } = await fetchDocument(document.url, { headers: httpHeaders, responseType })
    return isPdf ? createObjectUrl(data as Blob) : data
  }

  return document.data
}
